/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line func-names
(function (angular) {
    angular.module('app')
        .controller('featuredTilesController', featuredTilesController);

        featuredTilesController.$inject = [
        'thisSiteSettings',
        'FeaturedTilesApi',
    ];

    function featuredTilesController(
        thisSiteSettings,
        FeaturedTilesApi,
    ) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const vm = this;

        // Get true or false value from site's setting to see if featured tiles are enabled
        vm.featuredTilesEnabled = thisSiteSettings.featured_tiles.enabled;
        
        if (vm.featuredTilesEnabled) {
            // Handle the api call response - saves the response to featuredTiles variable
            const handleFeaturedTilesResponse = (response) => {
                vm.featuredTiles = response.data.value;
            };

            /**
             *  Run the api get call
             *  Can send the below parameters when impelementing filters
            */
            FeaturedTilesApi.get(handleFeaturedTilesResponse);
        }
    }
}(angular));
